<template>
  <div class="page page--step3">
    <div class="container">
      <div class="panel">
        <div class="panel-header">
          <h1>We'd also like to check&hellip;</h1>
          <p>Just a couple more background questions - thanks for your patience</p>
        </div>

        <div class="panel-body panel-body-flush">
          <Questions
            ref="questions"
            :section="2"
            previous-route="survey.step-2"
            next-route="survey.step-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Questions from "@/components/Survey/Questions"

export default {
  components: {
    Questions,
  },

  mounted() {
    this.goToStartIfNecessary();

    this.setCurrentStep(3);

    this.scrollToTop();
  },
};
</script>
